import { getAggregataForSearchQuery } from '../../redux/actions/searchActions';
import { Box, Stack, Skeleton, Typography, Link } from "@mui/material";
import  RelevantArticles  from './RelevantArticles.jsx';
import { useDispatch, useSelector } from 'react-redux';
import SimilarTickets  from "./SimilarTickets.jsx";
import  Workflows  from './Workflows.jsx';
import React, { useEffect } from 'react';

const SearchResearch = ({ searchQuery, subDomain, ticketingSystem, prismToken, ticketId, orgId, agentDetails, userEmail, ticketDetails, validSearch = false, searchInputRef, setTab }) => {
    const dispatch = useDispatch();
    const similarTickets = useSelector((state) => state.search.searchSimilarTickets);
    const relevantArticles = useSelector((state) => state.search.searchRelevantArticles);
    const workflows = useSelector((state) => state.search.searchWorkflows);
    const prevSearchQuery = useSelector((state) => state.search.searchQuery);
    const isRelevantArticlesLoading = useSelector((state) => state.search.searchArticlesloading);
    const workflowsLoading = useSelector((state) => state.search.searchWorkflowsLoading);
    const isloading = useSelector((state) => state.ticket.researchTabloading);
    const buttonLabels = useSelector((state) => state.article.searchArticlesbuttonlables);
    const loading = useSelector((state) => state.article.searchArticlesloading);
    const articleResponses = useSelector(state => state.article.searchArticleResponses);

    useEffect(() => {
        if (validSearch && prevSearchQuery !== searchQuery) {
            dispatch(getAggregataForSearchQuery(searchQuery, ticketDetails, agentDetails, userEmail, prismToken, orgId));
        }
    }, [validSearch]);

    const searchResults = similarTickets.length || relevantArticles.length;
    const queryText = searchQuery || ticketDetails?.question || ticketDetails?.subject;

    return (
        <Box padding={1}  sx={{ overflowY: 'auto', maxHeight: '100%' }}>
            {!searchResults ? (
                <Box textAlign="center" mt={4}>
                    <Typography variant="body1">
                        Click on{" "}
                        <Link component="button" underline="none" sx={{ fontWeight: 700, color: "#152938", transition: "transform 0.5s", "&:hover": { transform: "scale(1.05)" } }} onClick={() => setTab("Ticket Research")}>
                            Ticket Research
                        </Link>{" "}
                        or use the{" "}
                        <Link component="button" underline="none" sx={{ fontWeight: 700, color: "#152938", transition: "transform 0.5s", "&:hover": { transform: "scale(1.05)" } }} onClick={() => searchInputRef.current?.focus()}>
                            Search Bar
                        </Link>{" "}
                        to get started
                    </Typography>
                </Box>
            ) : (
                <Box>
                    {workflowsLoading ? (
                        <Box mb={3}>
                            <Stack spacing={1}>
                                <Skeleton variant="text" width="30%" />
                                <Skeleton variant="rectangular" height={60} />
                                <Skeleton variant="rectangular" height={60} />
                            </Stack>
                        </Box>
                    ) : (
                        <Workflows workflows={workflows} isloading={workflowsLoading} userEmail={userEmail} ticketDetails={ticketDetails} orgId={orgId} prismToken={prismToken} renderType="search" subDomain={subDomain} ticketingSystem={ticketingSystem} agentDetails={agentDetails} queryText={queryText} />
                    )}

                    {isRelevantArticlesLoading ? (
                        <Box mb={3}>
                            <Stack spacing={1}>
                                <Skeleton variant="text" width="40%" />
                                <Skeleton variant="text" width="80%" />
                                <Skeleton variant="text" width="90%" />
                                <Stack direction="row" spacing={1}>
                                    <Skeleton variant="rectangular" width={100} height={36} />
                                    <Skeleton variant="rectangular" width={100} height={36} />
                                </Stack>
                            </Stack>
                        </Box>
                    ) : (
                        <RelevantArticles relevantArticles={relevantArticles} articleResponses={articleResponses} isLoading={isRelevantArticlesLoading} buttonLabels={buttonLabels} loading={loading} prismToken={prismToken} ticketDetails={ticketDetails} userEmail={userEmail} renderType="search" orgId={orgId} queryText={queryText} ticketingSystem={ticketingSystem} subDomain={subDomain} agentDetails={agentDetails} />
                    )}

                    {!similarTickets ? (
                        <Box mb={3}>
                            <Stack spacing={2}>
                                {[1, 2, 3].map((item) => (
                                    <Stack direction="row" spacing={2} alignItems="center" key={item}>
                                        <Skeleton variant="circular" width={40} height={40} />
                                        <Stack spacing={0.5} width="100%">
                                            <Skeleton variant="text" width="60%" />
                                            <Skeleton variant="text" width="40%" />
                                        </Stack>
                                    </Stack>
                                ))}
                            </Stack>
                        </Box>
                    ) : (
                        <SimilarTickets similarTickets={similarTickets} userEmail={userEmail} ticketDetails={ticketDetails} orgId={orgId} prismToken={prismToken} renderType="search" agentDetails={agentDetails} ticketingSystem={ticketingSystem} subDomain={subDomain} queryText={queryText} />
                    )}
                </Box>
            )}
        </Box>
    );
};

export default SearchResearch;
